// This file is auto-generated by @hey-api/openapi-ts

import { type Options, listDocumentsDocumentsGet, getDocumentDocumentsKeyGet, getDocumentSnapshotDocumentsKeySnapshotGet, getDocumentPdfUrlDocumentsKeyPdfGet, getDocumentAuditTrailDocumentsKeyAuditTrailGet, assignReviewerToDocumentDocumentsKeyReviewerPost, getDocumentClusterInfoDocumentsKeyClusterInfoGet, getDocumentClassificationDocumentsKeyClassificationsGet, getDocumentClassificationReviewDocumentsKeyClassificationReviewsGet, addDocumentClassificationReviewDocumentsKeyClassificationReviewsPost, getDocumentExtractedDataDocumentsKeyExtractedDataGet, getDocumentExtractedDataDocumentsKeyExtractedDataLlmGet, getDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsGet, addDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsPost, getDocumentPatientMatchesDocumentsKeyPatientMatchesGet, getPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackGet, submitPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackPost, addPatientRecordDocumentsKeyPatientMatchesRecordsPost, deletePatientRecordDocumentsKeyPatientMatchesRecordsIndexDelete, editPatientRecordDocumentsKeyPatientMatchesRecordsIndexPut, getDocumentPatientPaMatchesDocumentsKeyPatientPaMatchesGet, getPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackGet, submitPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackPost, addPaPatientRecordDocumentsKeyPatientPaMatchesRecordsPost, deletePaPatientRecordDocumentsKeyPatientPaMatchesRecordsIndexDelete, editPaPatientRecordDocumentsKeyPatientPaMatchesRecordsIndexPut, updateDocumentPayorDocumentsKeyPayorPut, updateDocumentOnshoreOnlyFlagDocumentsKeyOnshoreOnlyPut, deleteDocumentThirdPartyDocumentsKeyThirdPartyDelete, updateDocumentThirdPartyDocumentsKeyThirdPartyPut, getDocumentTagsDocumentsKeyTagsGet, getDocumentTagsReviewsDocumentsKeyTagsReviewsGet, createDocumentTagsReviewDocumentsKeyTagsReviewsPost, updateDocumentReviewStatusDocumentsKeyReviewStatusPut, getDocumentFlagsDocumentsKeyFlagsGet, createDocumentFlagDocumentsKeyFlagsPost, updateDocumentFlagDocumentsKeyFlagsFlagKeyPatch, addDocumentFlagCommentDocumentsKeyFlagsFlagKeyCommentPost, resolveDocumentFlagDocumentsKeyFlagsFlagKeyResolvePost, listConsignmentsConsignmentsGet, getConsignmentConsignmentsKeyGet, updateClusterDocumentPageRangesConsignmentsKeyDocumentPageRangesPut, getConsignmentPdfUrlConsignmentsKeyPdfGet, getConsignmentOcrLayoutUrlConsignmentsKeyOcrLayoutGet, assignReviewerToConsignmentConsignmentsKeyReviewerPost, getPdfUploadUrlConsignmentsUploadPdfPost, listCategoriesCategoriesGet, listPayorsPayorsGet, listReviewersReviewersGet, getReviewerBySubReviewersSubGet, listInboxNamesInboxNamesGet, getCurrentUserProfileWithFeaturesMeGet, listAvalonCompletionsAvalonCompletionsGet, getPaymentSummaryDocumentsDocumentKeyEobSummaryGet, updatePaymentSummaryDocumentsDocumentKeyEobSummaryPut, getAllPatientClaimsDocumentsDocumentKeyEobClaimsGet, createPatientClaimDocumentsDocumentKeyEobClaimsPost, deletePatientClaimDocumentsDocumentKeyEobClaimsClaimKeyDelete, updatePatientClaimDocumentsDocumentKeyEobClaimsClaimKeyPut, validateEobProcessingDocumentsDocumentKeyEobValidatePost, listCarCsConfigCarcsGet, listRarCsConfigRarcsGet, listNateraTagsConfigTagsGet, getCarcToRarcMappingConfigCarcToRarcGet, listMedistreamConsignmentsMedistreamTrackingGet, medistreamTrackingSummaryMedistreamTrackingSummaryGet, downloadMedistreamTrackingReportCsvMedistreamTrackingReportGet, medistreamTrackingReportSummaryMedistreamTrackingReportSummaryGet, refreshMedistreamTrackingReportMedistreamTrackingReportRefreshPost, listDocumentsWithAgentRunsDocumentAgentRunsGet, listADocumentSAgentRunsDocumentAgentDocumentsKeyRunsGet, getAnAgentRunDocumentAgentDocumentsKeyRunsRunIdGet, getTheDocumentTextTheAgentReadDocumentAgentDocumentsKeyTextGet, getTheGoldSetReviewQueueGoldSetQueueGet, listTheGoldSetCategoriesGoldSetCategoriesGet, getAGoldSetDocumentGoldSetDocumentsKeyGet, saveAGoldSetLabelGoldSetDocumentsKeyLabelPut } from '../sdk.gen';
import { queryOptions, type UseMutationOptions, type DefaultError, infiniteQueryOptions, type InfiniteData } from '@tanstack/react-query';
import type { ListDocumentsDocumentsGetData, GetDocumentDocumentsKeyGetData, GetDocumentSnapshotDocumentsKeySnapshotGetData, GetDocumentPdfUrlDocumentsKeyPdfGetData, GetDocumentAuditTrailDocumentsKeyAuditTrailGetData, AssignReviewerToDocumentDocumentsKeyReviewerPostData, AssignReviewerToDocumentDocumentsKeyReviewerPostError, AssignReviewerToDocumentDocumentsKeyReviewerPostResponse, GetDocumentClusterInfoDocumentsKeyClusterInfoGetData, GetDocumentClassificationDocumentsKeyClassificationsGetData, GetDocumentClassificationReviewDocumentsKeyClassificationReviewsGetData, AddDocumentClassificationReviewDocumentsKeyClassificationReviewsPostData, AddDocumentClassificationReviewDocumentsKeyClassificationReviewsPostError, AddDocumentClassificationReviewDocumentsKeyClassificationReviewsPostResponse, GetDocumentExtractedDataDocumentsKeyExtractedDataGetData, GetDocumentExtractedDataDocumentsKeyExtractedDataLlmGetData, GetDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsGetData, AddDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsPostData, AddDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsPostError, AddDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsPostResponse, GetDocumentPatientMatchesDocumentsKeyPatientMatchesGetData, GetPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackGetData, SubmitPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackPostData, SubmitPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackPostError, SubmitPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackPostResponse, AddPatientRecordDocumentsKeyPatientMatchesRecordsPostData, AddPatientRecordDocumentsKeyPatientMatchesRecordsPostError, AddPatientRecordDocumentsKeyPatientMatchesRecordsPostResponse, DeletePatientRecordDocumentsKeyPatientMatchesRecordsIndexDeleteData, DeletePatientRecordDocumentsKeyPatientMatchesRecordsIndexDeleteError, DeletePatientRecordDocumentsKeyPatientMatchesRecordsIndexDeleteResponse, EditPatientRecordDocumentsKeyPatientMatchesRecordsIndexPutData, EditPatientRecordDocumentsKeyPatientMatchesRecordsIndexPutError, EditPatientRecordDocumentsKeyPatientMatchesRecordsIndexPutResponse, GetDocumentPatientPaMatchesDocumentsKeyPatientPaMatchesGetData, GetPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackGetData, SubmitPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackPostData, SubmitPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackPostError, SubmitPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackPostResponse, AddPaPatientRecordDocumentsKeyPatientPaMatchesRecordsPostData, AddPaPatientRecordDocumentsKeyPatientPaMatchesRecordsPostError, AddPaPatientRecordDocumentsKeyPatientPaMatchesRecordsPostResponse, DeletePaPatientRecordDocumentsKeyPatientPaMatchesRecordsIndexDeleteData, DeletePaPatientRecordDocumentsKeyPatientPaMatchesRecordsIndexDeleteError, DeletePaPatientRecordDocumentsKeyPatientPaMatchesRecordsIndexDeleteResponse, EditPaPatientRecordDocumentsKeyPatientPaMatchesRecordsIndexPutData, EditPaPatientRecordDocumentsKeyPatientPaMatchesRecordsIndexPutError, EditPaPatientRecordDocumentsKeyPatientPaMatchesRecordsIndexPutResponse, UpdateDocumentPayorDocumentsKeyPayorPutData, UpdateDocumentPayorDocumentsKeyPayorPutError, UpdateDocumentPayorDocumentsKeyPayorPutResponse, UpdateDocumentOnshoreOnlyFlagDocumentsKeyOnshoreOnlyPutData, UpdateDocumentOnshoreOnlyFlagDocumentsKeyOnshoreOnlyPutError, UpdateDocumentOnshoreOnlyFlagDocumentsKeyOnshoreOnlyPutResponse, DeleteDocumentThirdPartyDocumentsKeyThirdPartyDeleteData, DeleteDocumentThirdPartyDocumentsKeyThirdPartyDeleteError, DeleteDocumentThirdPartyDocumentsKeyThirdPartyDeleteResponse, UpdateDocumentThirdPartyDocumentsKeyThirdPartyPutData, UpdateDocumentThirdPartyDocumentsKeyThirdPartyPutError, UpdateDocumentThirdPartyDocumentsKeyThirdPartyPutResponse, GetDocumentTagsDocumentsKeyTagsGetData, GetDocumentTagsReviewsDocumentsKeyTagsReviewsGetData, CreateDocumentTagsReviewDocumentsKeyTagsReviewsPostData, CreateDocumentTagsReviewDocumentsKeyTagsReviewsPostError, CreateDocumentTagsReviewDocumentsKeyTagsReviewsPostResponse, UpdateDocumentReviewStatusDocumentsKeyReviewStatusPutData, UpdateDocumentReviewStatusDocumentsKeyReviewStatusPutError, UpdateDocumentReviewStatusDocumentsKeyReviewStatusPutResponse, GetDocumentFlagsDocumentsKeyFlagsGetData, CreateDocumentFlagDocumentsKeyFlagsPostData, CreateDocumentFlagDocumentsKeyFlagsPostError, CreateDocumentFlagDocumentsKeyFlagsPostResponse, UpdateDocumentFlagDocumentsKeyFlagsFlagKeyPatchData, UpdateDocumentFlagDocumentsKeyFlagsFlagKeyPatchError, UpdateDocumentFlagDocumentsKeyFlagsFlagKeyPatchResponse, AddDocumentFlagCommentDocumentsKeyFlagsFlagKeyCommentPostData, AddDocumentFlagCommentDocumentsKeyFlagsFlagKeyCommentPostError, AddDocumentFlagCommentDocumentsKeyFlagsFlagKeyCommentPostResponse, ResolveDocumentFlagDocumentsKeyFlagsFlagKeyResolvePostData, ResolveDocumentFlagDocumentsKeyFlagsFlagKeyResolvePostError, ResolveDocumentFlagDocumentsKeyFlagsFlagKeyResolvePostResponse, ListConsignmentsConsignmentsGetData, GetConsignmentConsignmentsKeyGetData, UpdateClusterDocumentPageRangesConsignmentsKeyDocumentPageRangesPutData, UpdateClusterDocumentPageRangesConsignmentsKeyDocumentPageRangesPutError, UpdateClusterDocumentPageRangesConsignmentsKeyDocumentPageRangesPutResponse, GetConsignmentPdfUrlConsignmentsKeyPdfGetData, GetConsignmentOcrLayoutUrlConsignmentsKeyOcrLayoutGetData, AssignReviewerToConsignmentConsignmentsKeyReviewerPostData, AssignReviewerToConsignmentConsignmentsKeyReviewerPostError, AssignReviewerToConsignmentConsignmentsKeyReviewerPostResponse, GetPdfUploadUrlConsignmentsUploadPdfPostData, GetPdfUploadUrlConsignmentsUploadPdfPostError, GetPdfUploadUrlConsignmentsUploadPdfPostResponse, ListCategoriesCategoriesGetData, ListPayorsPayorsGetData, ListReviewersReviewersGetData, GetReviewerBySubReviewersSubGetData, ListInboxNamesInboxNamesGetData, GetCurrentUserProfileWithFeaturesMeGetData, ListAvalonCompletionsAvalonCompletionsGetData, GetPaymentSummaryDocumentsDocumentKeyEobSummaryGetData, UpdatePaymentSummaryDocumentsDocumentKeyEobSummaryPutData, UpdatePaymentSummaryDocumentsDocumentKeyEobSummaryPutError, UpdatePaymentSummaryDocumentsDocumentKeyEobSummaryPutResponse, GetAllPatientClaimsDocumentsDocumentKeyEobClaimsGetData, CreatePatientClaimDocumentsDocumentKeyEobClaimsPostData, CreatePatientClaimDocumentsDocumentKeyEobClaimsPostError, CreatePatientClaimDocumentsDocumentKeyEobClaimsPostResponse, DeletePatientClaimDocumentsDocumentKeyEobClaimsClaimKeyDeleteData, DeletePatientClaimDocumentsDocumentKeyEobClaimsClaimKeyDeleteError, DeletePatientClaimDocumentsDocumentKeyEobClaimsClaimKeyDeleteResponse, UpdatePatientClaimDocumentsDocumentKeyEobClaimsClaimKeyPutData, UpdatePatientClaimDocumentsDocumentKeyEobClaimsClaimKeyPutError, UpdatePatientClaimDocumentsDocumentKeyEobClaimsClaimKeyPutResponse, ValidateEobProcessingDocumentsDocumentKeyEobValidatePostData, ValidateEobProcessingDocumentsDocumentKeyEobValidatePostError, ValidateEobProcessingDocumentsDocumentKeyEobValidatePostResponse, ListCarCsConfigCarcsGetData, ListRarCsConfigRarcsGetData, ListNateraTagsConfigTagsGetData, GetCarcToRarcMappingConfigCarcToRarcGetData, ListMedistreamConsignmentsMedistreamTrackingGetData, MedistreamTrackingSummaryMedistreamTrackingSummaryGetData, DownloadMedistreamTrackingReportCsvMedistreamTrackingReportGetData, MedistreamTrackingReportSummaryMedistreamTrackingReportSummaryGetData, RefreshMedistreamTrackingReportMedistreamTrackingReportRefreshPostData, RefreshMedistreamTrackingReportMedistreamTrackingReportRefreshPostResponse, ListDocumentsWithAgentRunsDocumentAgentRunsGetData, ListDocumentsWithAgentRunsDocumentAgentRunsGetError, ListDocumentsWithAgentRunsDocumentAgentRunsGetResponse, ListADocumentSAgentRunsDocumentAgentDocumentsKeyRunsGetData, GetAnAgentRunDocumentAgentDocumentsKeyRunsRunIdGetData, GetTheDocumentTextTheAgentReadDocumentAgentDocumentsKeyTextGetData, GetTheGoldSetReviewQueueGoldSetQueueGetData, ListTheGoldSetCategoriesGoldSetCategoriesGetData, GetAGoldSetDocumentGoldSetDocumentsKeyGetData, SaveAGoldSetLabelGoldSetDocumentsKeyLabelPutData, SaveAGoldSetLabelGoldSetDocumentsKeyLabelPutError, SaveAGoldSetLabelGoldSetDocumentsKeyLabelPutResponse } from '../types.gen';
import { client as _heyApiClient } from '../client.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? _heyApiClient).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [
        params
    ];
};

export const listDocumentsDocumentsGetQueryKey = (options?: Options<ListDocumentsDocumentsGetData>) => createQueryKey('listDocumentsDocumentsGet', options);

/**
 * List Documents
 */
export const listDocumentsDocumentsGetOptions = (options?: Options<ListDocumentsDocumentsGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listDocumentsDocumentsGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listDocumentsDocumentsGetQueryKey(options)
    });
};

export const getDocumentDocumentsKeyGetQueryKey = (options: Options<GetDocumentDocumentsKeyGetData>) => createQueryKey('getDocumentDocumentsKeyGet', options);

/**
 * Get Document
 */
export const getDocumentDocumentsKeyGetOptions = (options: Options<GetDocumentDocumentsKeyGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getDocumentDocumentsKeyGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getDocumentDocumentsKeyGetQueryKey(options)
    });
};

export const getDocumentSnapshotDocumentsKeySnapshotGetQueryKey = (options: Options<GetDocumentSnapshotDocumentsKeySnapshotGetData>) => createQueryKey('getDocumentSnapshotDocumentsKeySnapshotGet', options);

/**
 * Load a document and all of its related data in a single request
 * Return the full document view (document + clusters, classifications,
 * extracted data, tags, patient matches, flags, EOB, and reviews) assembled
 * from a single partition query, replacing the many per-object calls.
 */
export const getDocumentSnapshotDocumentsKeySnapshotGetOptions = (options: Options<GetDocumentSnapshotDocumentsKeySnapshotGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getDocumentSnapshotDocumentsKeySnapshotGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getDocumentSnapshotDocumentsKeySnapshotGetQueryKey(options)
    });
};

export const getDocumentPdfUrlDocumentsKeyPdfGetQueryKey = (options: Options<GetDocumentPdfUrlDocumentsKeyPdfGetData>) => createQueryKey('getDocumentPdfUrlDocumentsKeyPdfGet', options);

/**
 * Get Document Pdf Url
 */
export const getDocumentPdfUrlDocumentsKeyPdfGetOptions = (options: Options<GetDocumentPdfUrlDocumentsKeyPdfGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getDocumentPdfUrlDocumentsKeyPdfGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getDocumentPdfUrlDocumentsKeyPdfGetQueryKey(options)
    });
};

export const getDocumentAuditTrailDocumentsKeyAuditTrailGetQueryKey = (options: Options<GetDocumentAuditTrailDocumentsKeyAuditTrailGetData>) => createQueryKey('getDocumentAuditTrailDocumentsKeyAuditTrailGet', options);

/**
 * Get document audit trail with optional filtering
 * Get audit trail for a document with optional filtering.
 *
 * - **event_type=eob**: Returns only EOB-related events (payment summary, claims, service lines)
 * - **event_type** omitted: Returns all audit events for the document
 *
 * This unified endpoint replaces the separate /eob/audit-trail endpoint for better frontend integration.
 */
export const getDocumentAuditTrailDocumentsKeyAuditTrailGetOptions = (options: Options<GetDocumentAuditTrailDocumentsKeyAuditTrailGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getDocumentAuditTrailDocumentsKeyAuditTrailGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getDocumentAuditTrailDocumentsKeyAuditTrailGetQueryKey(options)
    });
};

export const assignReviewerToDocumentDocumentsKeyReviewerPostQueryKey = (options: Options<AssignReviewerToDocumentDocumentsKeyReviewerPostData>) => createQueryKey('assignReviewerToDocumentDocumentsKeyReviewerPost', options);

/**
 * Assign Reviewer To Document
 */
export const assignReviewerToDocumentDocumentsKeyReviewerPostOptions = (options: Options<AssignReviewerToDocumentDocumentsKeyReviewerPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await assignReviewerToDocumentDocumentsKeyReviewerPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: assignReviewerToDocumentDocumentsKeyReviewerPostQueryKey(options)
    });
};

/**
 * Assign Reviewer To Document
 */
export const assignReviewerToDocumentDocumentsKeyReviewerPostMutation = (options?: Partial<Options<AssignReviewerToDocumentDocumentsKeyReviewerPostData>>): UseMutationOptions<AssignReviewerToDocumentDocumentsKeyReviewerPostResponse, AssignReviewerToDocumentDocumentsKeyReviewerPostError, Options<AssignReviewerToDocumentDocumentsKeyReviewerPostData>> => {
    const mutationOptions: UseMutationOptions<AssignReviewerToDocumentDocumentsKeyReviewerPostResponse, AssignReviewerToDocumentDocumentsKeyReviewerPostError, Options<AssignReviewerToDocumentDocumentsKeyReviewerPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await assignReviewerToDocumentDocumentsKeyReviewerPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDocumentClusterInfoDocumentsKeyClusterInfoGetQueryKey = (options: Options<GetDocumentClusterInfoDocumentsKeyClusterInfoGetData>) => createQueryKey('getDocumentClusterInfoDocumentsKeyClusterInfoGet', options);

/**
 * Get Document Cluster Info
 */
export const getDocumentClusterInfoDocumentsKeyClusterInfoGetOptions = (options: Options<GetDocumentClusterInfoDocumentsKeyClusterInfoGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getDocumentClusterInfoDocumentsKeyClusterInfoGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getDocumentClusterInfoDocumentsKeyClusterInfoGetQueryKey(options)
    });
};

export const getDocumentClassificationDocumentsKeyClassificationsGetQueryKey = (options: Options<GetDocumentClassificationDocumentsKeyClassificationsGetData>) => createQueryKey('getDocumentClassificationDocumentsKeyClassificationsGet', options);

/**
 * Get Document Classification
 */
export const getDocumentClassificationDocumentsKeyClassificationsGetOptions = (options: Options<GetDocumentClassificationDocumentsKeyClassificationsGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getDocumentClassificationDocumentsKeyClassificationsGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getDocumentClassificationDocumentsKeyClassificationsGetQueryKey(options)
    });
};

export const getDocumentClassificationReviewDocumentsKeyClassificationReviewsGetQueryKey = (options: Options<GetDocumentClassificationReviewDocumentsKeyClassificationReviewsGetData>) => createQueryKey('getDocumentClassificationReviewDocumentsKeyClassificationReviewsGet', options);

/**
 * Get Document Classification Review
 */
export const getDocumentClassificationReviewDocumentsKeyClassificationReviewsGetOptions = (options: Options<GetDocumentClassificationReviewDocumentsKeyClassificationReviewsGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getDocumentClassificationReviewDocumentsKeyClassificationReviewsGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getDocumentClassificationReviewDocumentsKeyClassificationReviewsGetQueryKey(options)
    });
};

export const addDocumentClassificationReviewDocumentsKeyClassificationReviewsPostQueryKey = (options: Options<AddDocumentClassificationReviewDocumentsKeyClassificationReviewsPostData>) => createQueryKey('addDocumentClassificationReviewDocumentsKeyClassificationReviewsPost', options);

/**
 * Add Document Classification Review
 */
export const addDocumentClassificationReviewDocumentsKeyClassificationReviewsPostOptions = (options: Options<AddDocumentClassificationReviewDocumentsKeyClassificationReviewsPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await addDocumentClassificationReviewDocumentsKeyClassificationReviewsPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: addDocumentClassificationReviewDocumentsKeyClassificationReviewsPostQueryKey(options)
    });
};

/**
 * Add Document Classification Review
 */
export const addDocumentClassificationReviewDocumentsKeyClassificationReviewsPostMutation = (options?: Partial<Options<AddDocumentClassificationReviewDocumentsKeyClassificationReviewsPostData>>): UseMutationOptions<AddDocumentClassificationReviewDocumentsKeyClassificationReviewsPostResponse, AddDocumentClassificationReviewDocumentsKeyClassificationReviewsPostError, Options<AddDocumentClassificationReviewDocumentsKeyClassificationReviewsPostData>> => {
    const mutationOptions: UseMutationOptions<AddDocumentClassificationReviewDocumentsKeyClassificationReviewsPostResponse, AddDocumentClassificationReviewDocumentsKeyClassificationReviewsPostError, Options<AddDocumentClassificationReviewDocumentsKeyClassificationReviewsPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await addDocumentClassificationReviewDocumentsKeyClassificationReviewsPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDocumentExtractedDataDocumentsKeyExtractedDataGetQueryKey = (options: Options<GetDocumentExtractedDataDocumentsKeyExtractedDataGetData>) => createQueryKey('getDocumentExtractedDataDocumentsKeyExtractedDataGet', options);

/**
 * Get Document Extracted Data
 */
export const getDocumentExtractedDataDocumentsKeyExtractedDataGetOptions = (options: Options<GetDocumentExtractedDataDocumentsKeyExtractedDataGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getDocumentExtractedDataDocumentsKeyExtractedDataGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getDocumentExtractedDataDocumentsKeyExtractedDataGetQueryKey(options)
    });
};

export const getDocumentExtractedDataDocumentsKeyExtractedDataLlmGetQueryKey = (options: Options<GetDocumentExtractedDataDocumentsKeyExtractedDataLlmGetData>) => createQueryKey('getDocumentExtractedDataDocumentsKeyExtractedDataLlmGet', options);

/**
 * Get Document Extracted Data
 */
export const getDocumentExtractedDataDocumentsKeyExtractedDataLlmGetOptions = (options: Options<GetDocumentExtractedDataDocumentsKeyExtractedDataLlmGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getDocumentExtractedDataDocumentsKeyExtractedDataLlmGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getDocumentExtractedDataDocumentsKeyExtractedDataLlmGetQueryKey(options)
    });
};

export const getDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsGetQueryKey = (options: Options<GetDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsGetData>) => createQueryKey('getDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsGet', options);

/**
 * Get Document Extracted Data Review
 */
export const getDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsGetOptions = (options: Options<GetDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsGetQueryKey(options)
    });
};

export const addDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsPostQueryKey = (options: Options<AddDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsPostData>) => createQueryKey('addDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsPost', options);

/**
 * Add Document Extracted Data Review
 */
export const addDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsPostOptions = (options: Options<AddDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await addDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: addDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsPostQueryKey(options)
    });
};

/**
 * Add Document Extracted Data Review
 */
export const addDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsPostMutation = (options?: Partial<Options<AddDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsPostData>>): UseMutationOptions<AddDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsPostResponse, AddDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsPostError, Options<AddDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsPostData>> => {
    const mutationOptions: UseMutationOptions<AddDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsPostResponse, AddDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsPostError, Options<AddDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await addDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDocumentPatientMatchesDocumentsKeyPatientMatchesGetQueryKey = (options: Options<GetDocumentPatientMatchesDocumentsKeyPatientMatchesGetData>) => createQueryKey('getDocumentPatientMatchesDocumentsKeyPatientMatchesGet', options);

/**
 * Get Document Patient Matches
 */
export const getDocumentPatientMatchesDocumentsKeyPatientMatchesGetOptions = (options: Options<GetDocumentPatientMatchesDocumentsKeyPatientMatchesGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getDocumentPatientMatchesDocumentsKeyPatientMatchesGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getDocumentPatientMatchesDocumentsKeyPatientMatchesGetQueryKey(options)
    });
};

export const getPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackGetQueryKey = (options: Options<GetPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackGetData>) => createQueryKey('getPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackGet', options);

/**
 * Get Patient Case Match Feedback
 * Get patient case matching feedback/review data for a document
 */
export const getPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackGetOptions = (options: Options<GetPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackGetQueryKey(options)
    });
};

export const submitPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackPostQueryKey = (options: Options<SubmitPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackPostData>) => createQueryKey('submitPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackPost', options);

/**
 * Submit Patient Case Match Feedback
 */
export const submitPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackPostOptions = (options: Options<SubmitPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await submitPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: submitPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackPostQueryKey(options)
    });
};

/**
 * Submit Patient Case Match Feedback
 */
export const submitPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackPostMutation = (options?: Partial<Options<SubmitPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackPostData>>): UseMutationOptions<SubmitPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackPostResponse, SubmitPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackPostError, Options<SubmitPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackPostData>> => {
    const mutationOptions: UseMutationOptions<SubmitPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackPostResponse, SubmitPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackPostError, Options<SubmitPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await submitPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const addPatientRecordDocumentsKeyPatientMatchesRecordsPostQueryKey = (options: Options<AddPatientRecordDocumentsKeyPatientMatchesRecordsPostData>) => createQueryKey('addPatientRecordDocumentsKeyPatientMatchesRecordsPost', options);

/**
 * Add Patient Record
 * Add a new patient record to the patient_data array.
 */
export const addPatientRecordDocumentsKeyPatientMatchesRecordsPostOptions = (options: Options<AddPatientRecordDocumentsKeyPatientMatchesRecordsPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await addPatientRecordDocumentsKeyPatientMatchesRecordsPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: addPatientRecordDocumentsKeyPatientMatchesRecordsPostQueryKey(options)
    });
};

/**
 * Add Patient Record
 * Add a new patient record to the patient_data array.
 */
export const addPatientRecordDocumentsKeyPatientMatchesRecordsPostMutation = (options?: Partial<Options<AddPatientRecordDocumentsKeyPatientMatchesRecordsPostData>>): UseMutationOptions<AddPatientRecordDocumentsKeyPatientMatchesRecordsPostResponse, AddPatientRecordDocumentsKeyPatientMatchesRecordsPostError, Options<AddPatientRecordDocumentsKeyPatientMatchesRecordsPostData>> => {
    const mutationOptions: UseMutationOptions<AddPatientRecordDocumentsKeyPatientMatchesRecordsPostResponse, AddPatientRecordDocumentsKeyPatientMatchesRecordsPostError, Options<AddPatientRecordDocumentsKeyPatientMatchesRecordsPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await addPatientRecordDocumentsKeyPatientMatchesRecordsPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Patient Record
 * Delete a patient record from the patient_data array.
 */
export const deletePatientRecordDocumentsKeyPatientMatchesRecordsIndexDeleteMutation = (options?: Partial<Options<DeletePatientRecordDocumentsKeyPatientMatchesRecordsIndexDeleteData>>): UseMutationOptions<DeletePatientRecordDocumentsKeyPatientMatchesRecordsIndexDeleteResponse, DeletePatientRecordDocumentsKeyPatientMatchesRecordsIndexDeleteError, Options<DeletePatientRecordDocumentsKeyPatientMatchesRecordsIndexDeleteData>> => {
    const mutationOptions: UseMutationOptions<DeletePatientRecordDocumentsKeyPatientMatchesRecordsIndexDeleteResponse, DeletePatientRecordDocumentsKeyPatientMatchesRecordsIndexDeleteError, Options<DeletePatientRecordDocumentsKeyPatientMatchesRecordsIndexDeleteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deletePatientRecordDocumentsKeyPatientMatchesRecordsIndexDelete({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Edit Patient Record
 * Edit an existing patient record in the patient_data array.
 */
export const editPatientRecordDocumentsKeyPatientMatchesRecordsIndexPutMutation = (options?: Partial<Options<EditPatientRecordDocumentsKeyPatientMatchesRecordsIndexPutData>>): UseMutationOptions<EditPatientRecordDocumentsKeyPatientMatchesRecordsIndexPutResponse, EditPatientRecordDocumentsKeyPatientMatchesRecordsIndexPutError, Options<EditPatientRecordDocumentsKeyPatientMatchesRecordsIndexPutData>> => {
    const mutationOptions: UseMutationOptions<EditPatientRecordDocumentsKeyPatientMatchesRecordsIndexPutResponse, EditPatientRecordDocumentsKeyPatientMatchesRecordsIndexPutError, Options<EditPatientRecordDocumentsKeyPatientMatchesRecordsIndexPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await editPatientRecordDocumentsKeyPatientMatchesRecordsIndexPut({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDocumentPatientPaMatchesDocumentsKeyPatientPaMatchesGetQueryKey = (options: Options<GetDocumentPatientPaMatchesDocumentsKeyPatientPaMatchesGetData>) => createQueryKey('getDocumentPatientPaMatchesDocumentsKeyPatientPaMatchesGet', options);

/**
 * Get Document Patient Pa Matches
 */
export const getDocumentPatientPaMatchesDocumentsKeyPatientPaMatchesGetOptions = (options: Options<GetDocumentPatientPaMatchesDocumentsKeyPatientPaMatchesGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getDocumentPatientPaMatchesDocumentsKeyPatientPaMatchesGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getDocumentPatientPaMatchesDocumentsKeyPatientPaMatchesGetQueryKey(options)
    });
};

export const getPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackGetQueryKey = (options: Options<GetPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackGetData>) => createQueryKey('getPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackGet', options);

/**
 * Get Pa Case Match Feedback
 * Get PA case matching feedback/review data for a document
 */
export const getPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackGetOptions = (options: Options<GetPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackGetQueryKey(options)
    });
};

export const submitPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackPostQueryKey = (options: Options<SubmitPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackPostData>) => createQueryKey('submitPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackPost', options);

/**
 * Submit Pa Case Match Feedback
 */
export const submitPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackPostOptions = (options: Options<SubmitPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await submitPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: submitPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackPostQueryKey(options)
    });
};

/**
 * Submit Pa Case Match Feedback
 */
export const submitPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackPostMutation = (options?: Partial<Options<SubmitPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackPostData>>): UseMutationOptions<SubmitPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackPostResponse, SubmitPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackPostError, Options<SubmitPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackPostData>> => {
    const mutationOptions: UseMutationOptions<SubmitPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackPostResponse, SubmitPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackPostError, Options<SubmitPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await submitPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const addPaPatientRecordDocumentsKeyPatientPaMatchesRecordsPostQueryKey = (options: Options<AddPaPatientRecordDocumentsKeyPatientPaMatchesRecordsPostData>) => createQueryKey('addPaPatientRecordDocumentsKeyPatientPaMatchesRecordsPost', options);

/**
 * Add Pa Patient Record
 * Add a new PA patient record to the patient_data array.
 */
export const addPaPatientRecordDocumentsKeyPatientPaMatchesRecordsPostOptions = (options: Options<AddPaPatientRecordDocumentsKeyPatientPaMatchesRecordsPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await addPaPatientRecordDocumentsKeyPatientPaMatchesRecordsPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: addPaPatientRecordDocumentsKeyPatientPaMatchesRecordsPostQueryKey(options)
    });
};

/**
 * Add Pa Patient Record
 * Add a new PA patient record to the patient_data array.
 */
export const addPaPatientRecordDocumentsKeyPatientPaMatchesRecordsPostMutation = (options?: Partial<Options<AddPaPatientRecordDocumentsKeyPatientPaMatchesRecordsPostData>>): UseMutationOptions<AddPaPatientRecordDocumentsKeyPatientPaMatchesRecordsPostResponse, AddPaPatientRecordDocumentsKeyPatientPaMatchesRecordsPostError, Options<AddPaPatientRecordDocumentsKeyPatientPaMatchesRecordsPostData>> => {
    const mutationOptions: UseMutationOptions<AddPaPatientRecordDocumentsKeyPatientPaMatchesRecordsPostResponse, AddPaPatientRecordDocumentsKeyPatientPaMatchesRecordsPostError, Options<AddPaPatientRecordDocumentsKeyPatientPaMatchesRecordsPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await addPaPatientRecordDocumentsKeyPatientPaMatchesRecordsPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Pa Patient Record
 * Delete a PA patient record from the patient_data array.
 */
export const deletePaPatientRecordDocumentsKeyPatientPaMatchesRecordsIndexDeleteMutation = (options?: Partial<Options<DeletePaPatientRecordDocumentsKeyPatientPaMatchesRecordsIndexDeleteData>>): UseMutationOptions<DeletePaPatientRecordDocumentsKeyPatientPaMatchesRecordsIndexDeleteResponse, DeletePaPatientRecordDocumentsKeyPatientPaMatchesRecordsIndexDeleteError, Options<DeletePaPatientRecordDocumentsKeyPatientPaMatchesRecordsIndexDeleteData>> => {
    const mutationOptions: UseMutationOptions<DeletePaPatientRecordDocumentsKeyPatientPaMatchesRecordsIndexDeleteResponse, DeletePaPatientRecordDocumentsKeyPatientPaMatchesRecordsIndexDeleteError, Options<DeletePaPatientRecordDocumentsKeyPatientPaMatchesRecordsIndexDeleteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deletePaPatientRecordDocumentsKeyPatientPaMatchesRecordsIndexDelete({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Edit Pa Patient Record
 * Edit an existing PA patient record in the patient_data array.
 */
export const editPaPatientRecordDocumentsKeyPatientPaMatchesRecordsIndexPutMutation = (options?: Partial<Options<EditPaPatientRecordDocumentsKeyPatientPaMatchesRecordsIndexPutData>>): UseMutationOptions<EditPaPatientRecordDocumentsKeyPatientPaMatchesRecordsIndexPutResponse, EditPaPatientRecordDocumentsKeyPatientPaMatchesRecordsIndexPutError, Options<EditPaPatientRecordDocumentsKeyPatientPaMatchesRecordsIndexPutData>> => {
    const mutationOptions: UseMutationOptions<EditPaPatientRecordDocumentsKeyPatientPaMatchesRecordsIndexPutResponse, EditPaPatientRecordDocumentsKeyPatientPaMatchesRecordsIndexPutError, Options<EditPaPatientRecordDocumentsKeyPatientPaMatchesRecordsIndexPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await editPaPatientRecordDocumentsKeyPatientPaMatchesRecordsIndexPut({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Document Payor
 * Update document payor information.
 *
 * Accepts a payor_id and automatically looks up the corresponding
 * payor_group_id and onshore_only flag from the payors definitions.
 */
export const updateDocumentPayorDocumentsKeyPayorPutMutation = (options?: Partial<Options<UpdateDocumentPayorDocumentsKeyPayorPutData>>): UseMutationOptions<UpdateDocumentPayorDocumentsKeyPayorPutResponse, UpdateDocumentPayorDocumentsKeyPayorPutError, Options<UpdateDocumentPayorDocumentsKeyPayorPutData>> => {
    const mutationOptions: UseMutationOptions<UpdateDocumentPayorDocumentsKeyPayorPutResponse, UpdateDocumentPayorDocumentsKeyPayorPutError, Options<UpdateDocumentPayorDocumentsKeyPayorPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateDocumentPayorDocumentsKeyPayorPut({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Document Onshore Only Flag
 */
export const updateDocumentOnshoreOnlyFlagDocumentsKeyOnshoreOnlyPutMutation = (options?: Partial<Options<UpdateDocumentOnshoreOnlyFlagDocumentsKeyOnshoreOnlyPutData>>): UseMutationOptions<UpdateDocumentOnshoreOnlyFlagDocumentsKeyOnshoreOnlyPutResponse, UpdateDocumentOnshoreOnlyFlagDocumentsKeyOnshoreOnlyPutError, Options<UpdateDocumentOnshoreOnlyFlagDocumentsKeyOnshoreOnlyPutData>> => {
    const mutationOptions: UseMutationOptions<UpdateDocumentOnshoreOnlyFlagDocumentsKeyOnshoreOnlyPutResponse, UpdateDocumentOnshoreOnlyFlagDocumentsKeyOnshoreOnlyPutError, Options<UpdateDocumentOnshoreOnlyFlagDocumentsKeyOnshoreOnlyPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateDocumentOnshoreOnlyFlagDocumentsKeyOnshoreOnlyPut({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Document Third Party
 * Remove third party company information from document.
 */
export const deleteDocumentThirdPartyDocumentsKeyThirdPartyDeleteMutation = (options?: Partial<Options<DeleteDocumentThirdPartyDocumentsKeyThirdPartyDeleteData>>): UseMutationOptions<DeleteDocumentThirdPartyDocumentsKeyThirdPartyDeleteResponse, DeleteDocumentThirdPartyDocumentsKeyThirdPartyDeleteError, Options<DeleteDocumentThirdPartyDocumentsKeyThirdPartyDeleteData>> => {
    const mutationOptions: UseMutationOptions<DeleteDocumentThirdPartyDocumentsKeyThirdPartyDeleteResponse, DeleteDocumentThirdPartyDocumentsKeyThirdPartyDeleteError, Options<DeleteDocumentThirdPartyDocumentsKeyThirdPartyDeleteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteDocumentThirdPartyDocumentsKeyThirdPartyDelete({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Document Third Party
 * Update document third party company information.
 */
export const updateDocumentThirdPartyDocumentsKeyThirdPartyPutMutation = (options?: Partial<Options<UpdateDocumentThirdPartyDocumentsKeyThirdPartyPutData>>): UseMutationOptions<UpdateDocumentThirdPartyDocumentsKeyThirdPartyPutResponse, UpdateDocumentThirdPartyDocumentsKeyThirdPartyPutError, Options<UpdateDocumentThirdPartyDocumentsKeyThirdPartyPutData>> => {
    const mutationOptions: UseMutationOptions<UpdateDocumentThirdPartyDocumentsKeyThirdPartyPutResponse, UpdateDocumentThirdPartyDocumentsKeyThirdPartyPutError, Options<UpdateDocumentThirdPartyDocumentsKeyThirdPartyPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateDocumentThirdPartyDocumentsKeyThirdPartyPut({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDocumentTagsDocumentsKeyTagsGetQueryKey = (options: Options<GetDocumentTagsDocumentsKeyTagsGetData>) => createQueryKey('getDocumentTagsDocumentsKeyTagsGet', options);

/**
 * Get Document Tags
 * Get all tags (CARC, RARC, Triple P) for a document.
 *
 * Returns:
 * - For new docs (tags-* exists): Returns tags-* data with key="tags-xxx"
 * - For old docs (only data-*): Fallback to data-*, returns key="data-xxx"
 *
 * The frontend should use the returned `key` value as `data_key` in POST requests.
 * (For backward compatibility the API also accepts the legacy name `data_key`.)
 */
export const getDocumentTagsDocumentsKeyTagsGetOptions = (options: Options<GetDocumentTagsDocumentsKeyTagsGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getDocumentTagsDocumentsKeyTagsGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getDocumentTagsDocumentsKeyTagsGetQueryKey(options)
    });
};

export const getDocumentTagsReviewsDocumentsKeyTagsReviewsGetQueryKey = (options: Options<GetDocumentTagsReviewsDocumentsKeyTagsReviewsGetData>) => createQueryKey('getDocumentTagsReviewsDocumentsKeyTagsReviewsGet', options);

/**
 * Get Document Tags Reviews
 * Get review history for tags.
 *
 * Returns all reviews (datarev-* for audit trail).
 * Mirror write ensures this is always up to date regardless of which model was used.
 */
export const getDocumentTagsReviewsDocumentsKeyTagsReviewsGetOptions = (options: Options<GetDocumentTagsReviewsDocumentsKeyTagsReviewsGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getDocumentTagsReviewsDocumentsKeyTagsReviewsGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getDocumentTagsReviewsDocumentsKeyTagsReviewsGetQueryKey(options)
    });
};

export const createDocumentTagsReviewDocumentsKeyTagsReviewsPostQueryKey = (options: Options<CreateDocumentTagsReviewDocumentsKeyTagsReviewsPostData>) => createQueryKey('createDocumentTagsReviewDocumentsKeyTagsReviewsPost', options);

/**
 * Create Document Tags Review
 * Create a new tags review with mirror write.
 *
 * Routes by key prefix (request accepts `data_key` or legacy `data_key`):
 * - "data-xxx" → legacy extracted data model
 * - "tags-xxx" → new tags model
 *
 * Both flows perform mirror write to keep old and new models in sync.
 */
export const createDocumentTagsReviewDocumentsKeyTagsReviewsPostOptions = (options: Options<CreateDocumentTagsReviewDocumentsKeyTagsReviewsPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createDocumentTagsReviewDocumentsKeyTagsReviewsPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createDocumentTagsReviewDocumentsKeyTagsReviewsPostQueryKey(options)
    });
};

/**
 * Create Document Tags Review
 * Create a new tags review with mirror write.
 *
 * Routes by key prefix (request accepts `data_key` or legacy `data_key`):
 * - "data-xxx" → legacy extracted data model
 * - "tags-xxx" → new tags model
 *
 * Both flows perform mirror write to keep old and new models in sync.
 */
export const createDocumentTagsReviewDocumentsKeyTagsReviewsPostMutation = (options?: Partial<Options<CreateDocumentTagsReviewDocumentsKeyTagsReviewsPostData>>): UseMutationOptions<CreateDocumentTagsReviewDocumentsKeyTagsReviewsPostResponse, CreateDocumentTagsReviewDocumentsKeyTagsReviewsPostError, Options<CreateDocumentTagsReviewDocumentsKeyTagsReviewsPostData>> => {
    const mutationOptions: UseMutationOptions<CreateDocumentTagsReviewDocumentsKeyTagsReviewsPostResponse, CreateDocumentTagsReviewDocumentsKeyTagsReviewsPostError, Options<CreateDocumentTagsReviewDocumentsKeyTagsReviewsPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createDocumentTagsReviewDocumentsKeyTagsReviewsPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Document Review Status
 */
export const updateDocumentReviewStatusDocumentsKeyReviewStatusPutMutation = (options?: Partial<Options<UpdateDocumentReviewStatusDocumentsKeyReviewStatusPutData>>): UseMutationOptions<UpdateDocumentReviewStatusDocumentsKeyReviewStatusPutResponse, UpdateDocumentReviewStatusDocumentsKeyReviewStatusPutError, Options<UpdateDocumentReviewStatusDocumentsKeyReviewStatusPutData>> => {
    const mutationOptions: UseMutationOptions<UpdateDocumentReviewStatusDocumentsKeyReviewStatusPutResponse, UpdateDocumentReviewStatusDocumentsKeyReviewStatusPutError, Options<UpdateDocumentReviewStatusDocumentsKeyReviewStatusPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateDocumentReviewStatusDocumentsKeyReviewStatusPut({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDocumentFlagsDocumentsKeyFlagsGetQueryKey = (options: Options<GetDocumentFlagsDocumentsKeyFlagsGetData>) => createQueryKey('getDocumentFlagsDocumentsKeyFlagsGet', options);

/**
 * Get Document Flags
 * Get all flags for a document
 */
export const getDocumentFlagsDocumentsKeyFlagsGetOptions = (options: Options<GetDocumentFlagsDocumentsKeyFlagsGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getDocumentFlagsDocumentsKeyFlagsGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getDocumentFlagsDocumentsKeyFlagsGetQueryKey(options)
    });
};

export const createDocumentFlagDocumentsKeyFlagsPostQueryKey = (options: Options<CreateDocumentFlagDocumentsKeyFlagsPostData>) => createQueryKey('createDocumentFlagDocumentsKeyFlagsPost', options);

/**
 * Create Document Flag
 * Create a new flag for a document
 */
export const createDocumentFlagDocumentsKeyFlagsPostOptions = (options: Options<CreateDocumentFlagDocumentsKeyFlagsPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createDocumentFlagDocumentsKeyFlagsPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createDocumentFlagDocumentsKeyFlagsPostQueryKey(options)
    });
};

/**
 * Create Document Flag
 * Create a new flag for a document
 */
export const createDocumentFlagDocumentsKeyFlagsPostMutation = (options?: Partial<Options<CreateDocumentFlagDocumentsKeyFlagsPostData>>): UseMutationOptions<CreateDocumentFlagDocumentsKeyFlagsPostResponse, CreateDocumentFlagDocumentsKeyFlagsPostError, Options<CreateDocumentFlagDocumentsKeyFlagsPostData>> => {
    const mutationOptions: UseMutationOptions<CreateDocumentFlagDocumentsKeyFlagsPostResponse, CreateDocumentFlagDocumentsKeyFlagsPostError, Options<CreateDocumentFlagDocumentsKeyFlagsPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createDocumentFlagDocumentsKeyFlagsPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Document Flag
 * Update an existing flag (only notes and metadata are mutable)
 */
export const updateDocumentFlagDocumentsKeyFlagsFlagKeyPatchMutation = (options?: Partial<Options<UpdateDocumentFlagDocumentsKeyFlagsFlagKeyPatchData>>): UseMutationOptions<UpdateDocumentFlagDocumentsKeyFlagsFlagKeyPatchResponse, UpdateDocumentFlagDocumentsKeyFlagsFlagKeyPatchError, Options<UpdateDocumentFlagDocumentsKeyFlagsFlagKeyPatchData>> => {
    const mutationOptions: UseMutationOptions<UpdateDocumentFlagDocumentsKeyFlagsFlagKeyPatchResponse, UpdateDocumentFlagDocumentsKeyFlagsFlagKeyPatchError, Options<UpdateDocumentFlagDocumentsKeyFlagsFlagKeyPatchData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateDocumentFlagDocumentsKeyFlagsFlagKeyPatch({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const addDocumentFlagCommentDocumentsKeyFlagsFlagKeyCommentPostQueryKey = (options: Options<AddDocumentFlagCommentDocumentsKeyFlagsFlagKeyCommentPostData>) => createQueryKey('addDocumentFlagCommentDocumentsKeyFlagsFlagKeyCommentPost', options);

/**
 * Add Document Flag Comment
 * Add a comment to an existing flag without changing document state.
 */
export const addDocumentFlagCommentDocumentsKeyFlagsFlagKeyCommentPostOptions = (options: Options<AddDocumentFlagCommentDocumentsKeyFlagsFlagKeyCommentPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await addDocumentFlagCommentDocumentsKeyFlagsFlagKeyCommentPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: addDocumentFlagCommentDocumentsKeyFlagsFlagKeyCommentPostQueryKey(options)
    });
};

/**
 * Add Document Flag Comment
 * Add a comment to an existing flag without changing document state.
 */
export const addDocumentFlagCommentDocumentsKeyFlagsFlagKeyCommentPostMutation = (options?: Partial<Options<AddDocumentFlagCommentDocumentsKeyFlagsFlagKeyCommentPostData>>): UseMutationOptions<AddDocumentFlagCommentDocumentsKeyFlagsFlagKeyCommentPostResponse, AddDocumentFlagCommentDocumentsKeyFlagsFlagKeyCommentPostError, Options<AddDocumentFlagCommentDocumentsKeyFlagsFlagKeyCommentPostData>> => {
    const mutationOptions: UseMutationOptions<AddDocumentFlagCommentDocumentsKeyFlagsFlagKeyCommentPostResponse, AddDocumentFlagCommentDocumentsKeyFlagsFlagKeyCommentPostError, Options<AddDocumentFlagCommentDocumentsKeyFlagsFlagKeyCommentPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await addDocumentFlagCommentDocumentsKeyFlagsFlagKeyCommentPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const resolveDocumentFlagDocumentsKeyFlagsFlagKeyResolvePostQueryKey = (options: Options<ResolveDocumentFlagDocumentsKeyFlagsFlagKeyResolvePostData>) => createQueryKey('resolveDocumentFlagDocumentsKeyFlagsFlagKeyResolvePost', options);

/**
 * Resolve Document Flag
 * Resolve a flag
 */
export const resolveDocumentFlagDocumentsKeyFlagsFlagKeyResolvePostOptions = (options: Options<ResolveDocumentFlagDocumentsKeyFlagsFlagKeyResolvePostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await resolveDocumentFlagDocumentsKeyFlagsFlagKeyResolvePost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: resolveDocumentFlagDocumentsKeyFlagsFlagKeyResolvePostQueryKey(options)
    });
};

/**
 * Resolve Document Flag
 * Resolve a flag
 */
export const resolveDocumentFlagDocumentsKeyFlagsFlagKeyResolvePostMutation = (options?: Partial<Options<ResolveDocumentFlagDocumentsKeyFlagsFlagKeyResolvePostData>>): UseMutationOptions<ResolveDocumentFlagDocumentsKeyFlagsFlagKeyResolvePostResponse, ResolveDocumentFlagDocumentsKeyFlagsFlagKeyResolvePostError, Options<ResolveDocumentFlagDocumentsKeyFlagsFlagKeyResolvePostData>> => {
    const mutationOptions: UseMutationOptions<ResolveDocumentFlagDocumentsKeyFlagsFlagKeyResolvePostResponse, ResolveDocumentFlagDocumentsKeyFlagsFlagKeyResolvePostError, Options<ResolveDocumentFlagDocumentsKeyFlagsFlagKeyResolvePostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await resolveDocumentFlagDocumentsKeyFlagsFlagKeyResolvePost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listConsignmentsConsignmentsGetQueryKey = (options?: Options<ListConsignmentsConsignmentsGetData>) => createQueryKey('listConsignmentsConsignmentsGet', options);

/**
 * List Consignments
 */
export const listConsignmentsConsignmentsGetOptions = (options?: Options<ListConsignmentsConsignmentsGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listConsignmentsConsignmentsGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listConsignmentsConsignmentsGetQueryKey(options)
    });
};

export const getConsignmentConsignmentsKeyGetQueryKey = (options: Options<GetConsignmentConsignmentsKeyGetData>) => createQueryKey('getConsignmentConsignmentsKeyGet', options);

/**
 * Get Consignment
 */
export const getConsignmentConsignmentsKeyGetOptions = (options: Options<GetConsignmentConsignmentsKeyGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getConsignmentConsignmentsKeyGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getConsignmentConsignmentsKeyGetQueryKey(options)
    });
};

/**
 * Update Cluster Document Page Ranges
 */
export const updateClusterDocumentPageRangesConsignmentsKeyDocumentPageRangesPutMutation = (options?: Partial<Options<UpdateClusterDocumentPageRangesConsignmentsKeyDocumentPageRangesPutData>>): UseMutationOptions<UpdateClusterDocumentPageRangesConsignmentsKeyDocumentPageRangesPutResponse, UpdateClusterDocumentPageRangesConsignmentsKeyDocumentPageRangesPutError, Options<UpdateClusterDocumentPageRangesConsignmentsKeyDocumentPageRangesPutData>> => {
    const mutationOptions: UseMutationOptions<UpdateClusterDocumentPageRangesConsignmentsKeyDocumentPageRangesPutResponse, UpdateClusterDocumentPageRangesConsignmentsKeyDocumentPageRangesPutError, Options<UpdateClusterDocumentPageRangesConsignmentsKeyDocumentPageRangesPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateClusterDocumentPageRangesConsignmentsKeyDocumentPageRangesPut({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getConsignmentPdfUrlConsignmentsKeyPdfGetQueryKey = (options: Options<GetConsignmentPdfUrlConsignmentsKeyPdfGetData>) => createQueryKey('getConsignmentPdfUrlConsignmentsKeyPdfGet', options);

/**
 * Get Consignment Pdf Url
 */
export const getConsignmentPdfUrlConsignmentsKeyPdfGetOptions = (options: Options<GetConsignmentPdfUrlConsignmentsKeyPdfGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getConsignmentPdfUrlConsignmentsKeyPdfGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getConsignmentPdfUrlConsignmentsKeyPdfGetQueryKey(options)
    });
};

export const getConsignmentOcrLayoutUrlConsignmentsKeyOcrLayoutGetQueryKey = (options: Options<GetConsignmentOcrLayoutUrlConsignmentsKeyOcrLayoutGetData>) => createQueryKey('getConsignmentOcrLayoutUrlConsignmentsKeyOcrLayoutGet', options);

/**
 * Get Consignment Ocr Layout Url
 */
export const getConsignmentOcrLayoutUrlConsignmentsKeyOcrLayoutGetOptions = (options: Options<GetConsignmentOcrLayoutUrlConsignmentsKeyOcrLayoutGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getConsignmentOcrLayoutUrlConsignmentsKeyOcrLayoutGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getConsignmentOcrLayoutUrlConsignmentsKeyOcrLayoutGetQueryKey(options)
    });
};

export const assignReviewerToConsignmentConsignmentsKeyReviewerPostQueryKey = (options: Options<AssignReviewerToConsignmentConsignmentsKeyReviewerPostData>) => createQueryKey('assignReviewerToConsignmentConsignmentsKeyReviewerPost', options);

/**
 * Assign Reviewer To Consignment
 */
export const assignReviewerToConsignmentConsignmentsKeyReviewerPostOptions = (options: Options<AssignReviewerToConsignmentConsignmentsKeyReviewerPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await assignReviewerToConsignmentConsignmentsKeyReviewerPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: assignReviewerToConsignmentConsignmentsKeyReviewerPostQueryKey(options)
    });
};

/**
 * Assign Reviewer To Consignment
 */
export const assignReviewerToConsignmentConsignmentsKeyReviewerPostMutation = (options?: Partial<Options<AssignReviewerToConsignmentConsignmentsKeyReviewerPostData>>): UseMutationOptions<AssignReviewerToConsignmentConsignmentsKeyReviewerPostResponse, AssignReviewerToConsignmentConsignmentsKeyReviewerPostError, Options<AssignReviewerToConsignmentConsignmentsKeyReviewerPostData>> => {
    const mutationOptions: UseMutationOptions<AssignReviewerToConsignmentConsignmentsKeyReviewerPostResponse, AssignReviewerToConsignmentConsignmentsKeyReviewerPostError, Options<AssignReviewerToConsignmentConsignmentsKeyReviewerPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await assignReviewerToConsignmentConsignmentsKeyReviewerPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPdfUploadUrlConsignmentsUploadPdfPostQueryKey = (options: Options<GetPdfUploadUrlConsignmentsUploadPdfPostData>) => createQueryKey('getPdfUploadUrlConsignmentsUploadPdfPost', options);

/**
 * Get Pdf Upload Url
 */
export const getPdfUploadUrlConsignmentsUploadPdfPostOptions = (options: Options<GetPdfUploadUrlConsignmentsUploadPdfPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPdfUploadUrlConsignmentsUploadPdfPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPdfUploadUrlConsignmentsUploadPdfPostQueryKey(options)
    });
};

/**
 * Get Pdf Upload Url
 */
export const getPdfUploadUrlConsignmentsUploadPdfPostMutation = (options?: Partial<Options<GetPdfUploadUrlConsignmentsUploadPdfPostData>>): UseMutationOptions<GetPdfUploadUrlConsignmentsUploadPdfPostResponse, GetPdfUploadUrlConsignmentsUploadPdfPostError, Options<GetPdfUploadUrlConsignmentsUploadPdfPostData>> => {
    const mutationOptions: UseMutationOptions<GetPdfUploadUrlConsignmentsUploadPdfPostResponse, GetPdfUploadUrlConsignmentsUploadPdfPostError, Options<GetPdfUploadUrlConsignmentsUploadPdfPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await getPdfUploadUrlConsignmentsUploadPdfPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listCategoriesCategoriesGetQueryKey = (options?: Options<ListCategoriesCategoriesGetData>) => createQueryKey('listCategoriesCategoriesGet', options);

/**
 * List Categories
 */
export const listCategoriesCategoriesGetOptions = (options?: Options<ListCategoriesCategoriesGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listCategoriesCategoriesGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listCategoriesCategoriesGetQueryKey(options)
    });
};

export const listPayorsPayorsGetQueryKey = (options?: Options<ListPayorsPayorsGetData>) => createQueryKey('listPayorsPayorsGet', options);

/**
 * List Payors
 * Get all payors definitions.
 */
export const listPayorsPayorsGetOptions = (options?: Options<ListPayorsPayorsGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listPayorsPayorsGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listPayorsPayorsGetQueryKey(options)
    });
};

export const listReviewersReviewersGetQueryKey = (options?: Options<ListReviewersReviewersGetData>) => createQueryKey('listReviewersReviewersGet', options);

/**
 * List Reviewers
 */
export const listReviewersReviewersGetOptions = (options?: Options<ListReviewersReviewersGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listReviewersReviewersGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listReviewersReviewersGetQueryKey(options)
    });
};

export const getReviewerBySubReviewersSubGetQueryKey = (options: Options<GetReviewerBySubReviewersSubGetData>) => createQueryKey('getReviewerBySubReviewersSubGet', options);

/**
 * Get Reviewer By Sub
 */
export const getReviewerBySubReviewersSubGetOptions = (options: Options<GetReviewerBySubReviewersSubGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getReviewerBySubReviewersSubGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getReviewerBySubReviewersSubGetQueryKey(options)
    });
};

export const listInboxNamesInboxNamesGetQueryKey = (options?: Options<ListInboxNamesInboxNamesGetData>) => createQueryKey('listInboxNamesInboxNamesGet', options);

/**
 * List Inbox Names
 */
export const listInboxNamesInboxNamesGetOptions = (options?: Options<ListInboxNamesInboxNamesGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listInboxNamesInboxNamesGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listInboxNamesInboxNamesGetQueryKey(options)
    });
};

export const getCurrentUserProfileWithFeaturesMeGetQueryKey = (options?: Options<GetCurrentUserProfileWithFeaturesMeGetData>) => createQueryKey('getCurrentUserProfileWithFeaturesMeGet', options);

/**
 * Get Current User Profile With Features
 * Get the current user's profile information including Unleash feature flags.
 *
 * Returns:
 * UserProfile: User information with feature flags
 */
export const getCurrentUserProfileWithFeaturesMeGetOptions = (options?: Options<GetCurrentUserProfileWithFeaturesMeGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCurrentUserProfileWithFeaturesMeGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getCurrentUserProfileWithFeaturesMeGetQueryKey(options)
    });
};

export const listAvalonCompletionsAvalonCompletionsGetQueryKey = (options?: Options<ListAvalonCompletionsAvalonCompletionsGetData>) => createQueryKey('listAvalonCompletionsAvalonCompletionsGet', options);

/**
 * List Avalon Completions
 */
export const listAvalonCompletionsAvalonCompletionsGetOptions = (options?: Options<ListAvalonCompletionsAvalonCompletionsGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listAvalonCompletionsAvalonCompletionsGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listAvalonCompletionsAvalonCompletionsGetQueryKey(options)
    });
};

export const getPaymentSummaryDocumentsDocumentKeyEobSummaryGetQueryKey = (options: Options<GetPaymentSummaryDocumentsDocumentKeyEobSummaryGetData>) => createQueryKey('getPaymentSummaryDocumentsDocumentKeyEobSummaryGet', options);

/**
 * Get payment summary for document
 * Get payment summary including workflow state fields.
 *
 * **Returns:** PaymentSummary with existing fields + workflow state
 */
export const getPaymentSummaryDocumentsDocumentKeyEobSummaryGetOptions = (options: Options<GetPaymentSummaryDocumentsDocumentKeyEobSummaryGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPaymentSummaryDocumentsDocumentKeyEobSummaryGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPaymentSummaryDocumentsDocumentKeyEobSummaryGetQueryKey(options)
    });
};

/**
 * Update payment summary with workflow state
 * Update payment summary including workflow state fields.
 *
 * **Supports:** receipt_confirmed, no_duplicates_in_amd, status updates
 */
export const updatePaymentSummaryDocumentsDocumentKeyEobSummaryPutMutation = (options?: Partial<Options<UpdatePaymentSummaryDocumentsDocumentKeyEobSummaryPutData>>): UseMutationOptions<UpdatePaymentSummaryDocumentsDocumentKeyEobSummaryPutResponse, UpdatePaymentSummaryDocumentsDocumentKeyEobSummaryPutError, Options<UpdatePaymentSummaryDocumentsDocumentKeyEobSummaryPutData>> => {
    const mutationOptions: UseMutationOptions<UpdatePaymentSummaryDocumentsDocumentKeyEobSummaryPutResponse, UpdatePaymentSummaryDocumentsDocumentKeyEobSummaryPutError, Options<UpdatePaymentSummaryDocumentsDocumentKeyEobSummaryPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updatePaymentSummaryDocumentsDocumentKeyEobSummaryPut({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAllPatientClaimsDocumentsDocumentKeyEobClaimsGetQueryKey = (options: Options<GetAllPatientClaimsDocumentsDocumentKeyEobClaimsGetData>) => createQueryKey('getAllPatientClaimsDocumentsDocumentKeyEobClaimsGet', options);

/**
 * Get all patient claims with embedded service lines
 * Get all patient claims for document with embedded service lines.
 *
 * **Returns:** List of PatientClaims, each containing service_lines array
 */
export const getAllPatientClaimsDocumentsDocumentKeyEobClaimsGetOptions = (options: Options<GetAllPatientClaimsDocumentsDocumentKeyEobClaimsGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAllPatientClaimsDocumentsDocumentKeyEobClaimsGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAllPatientClaimsDocumentsDocumentKeyEobClaimsGetQueryKey(options)
    });
};

export const createPatientClaimDocumentsDocumentKeyEobClaimsPostQueryKey = (options: Options<CreatePatientClaimDocumentsDocumentKeyEobClaimsPostData>) => createQueryKey('createPatientClaimDocumentsDocumentKeyEobClaimsPost', options);

/**
 * Create patient claim with optional service lines
 * Create patient claim with optional bulk service lines creation.
 *
 * **Example request:**
 * ```json
 * {
 * "patient_account_number": "12345",
 * "total_charged_amount": "500.00",
 * "service_lines": [
 * {
 * "procedure_code": "99213",
 * "charged_amount": "200.00",
 * "service_date": "2024-03-10"
 * },
 * {
 * "procedure_code": "99214",
 * "charged_amount": "300.00",
 * "service_date": "2024-03-10"
 * }
 * ]
 * }
 * ```
 *
 * **Returns:** Created PatientClaim with embedded service_lines
 */
export const createPatientClaimDocumentsDocumentKeyEobClaimsPostOptions = (options: Options<CreatePatientClaimDocumentsDocumentKeyEobClaimsPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createPatientClaimDocumentsDocumentKeyEobClaimsPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createPatientClaimDocumentsDocumentKeyEobClaimsPostQueryKey(options)
    });
};

/**
 * Create patient claim with optional service lines
 * Create patient claim with optional bulk service lines creation.
 *
 * **Example request:**
 * ```json
 * {
 * "patient_account_number": "12345",
 * "total_charged_amount": "500.00",
 * "service_lines": [
 * {
 * "procedure_code": "99213",
 * "charged_amount": "200.00",
 * "service_date": "2024-03-10"
 * },
 * {
 * "procedure_code": "99214",
 * "charged_amount": "300.00",
 * "service_date": "2024-03-10"
 * }
 * ]
 * }
 * ```
 *
 * **Returns:** Created PatientClaim with embedded service_lines
 */
export const createPatientClaimDocumentsDocumentKeyEobClaimsPostMutation = (options?: Partial<Options<CreatePatientClaimDocumentsDocumentKeyEobClaimsPostData>>): UseMutationOptions<CreatePatientClaimDocumentsDocumentKeyEobClaimsPostResponse, CreatePatientClaimDocumentsDocumentKeyEobClaimsPostError, Options<CreatePatientClaimDocumentsDocumentKeyEobClaimsPostData>> => {
    const mutationOptions: UseMutationOptions<CreatePatientClaimDocumentsDocumentKeyEobClaimsPostResponse, CreatePatientClaimDocumentsDocumentKeyEobClaimsPostError, Options<CreatePatientClaimDocumentsDocumentKeyEobClaimsPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createPatientClaimDocumentsDocumentKeyEobClaimsPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete patient claim (cascade deletes service lines)
 * Delete patient claim (soft delete with cascade to service lines).
 */
export const deletePatientClaimDocumentsDocumentKeyEobClaimsClaimKeyDeleteMutation = (options?: Partial<Options<DeletePatientClaimDocumentsDocumentKeyEobClaimsClaimKeyDeleteData>>): UseMutationOptions<DeletePatientClaimDocumentsDocumentKeyEobClaimsClaimKeyDeleteResponse, DeletePatientClaimDocumentsDocumentKeyEobClaimsClaimKeyDeleteError, Options<DeletePatientClaimDocumentsDocumentKeyEobClaimsClaimKeyDeleteData>> => {
    const mutationOptions: UseMutationOptions<DeletePatientClaimDocumentsDocumentKeyEobClaimsClaimKeyDeleteResponse, DeletePatientClaimDocumentsDocumentKeyEobClaimsClaimKeyDeleteError, Options<DeletePatientClaimDocumentsDocumentKeyEobClaimsClaimKeyDeleteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deletePatientClaimDocumentsDocumentKeyEobClaimsClaimKeyDelete({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update patient claim with bulk service line operations
 * Update patient claim with bulk service line diff operations.
 *
 * **Critical Bulk Operations Logic:**
 * - Missing service_line_id: CREATE new service line
 * - Existing service_line_id: UPDATE existing service line
 * - Service lines in DB but not in request: DELETE from DB
 * - Empty service_lines array: DELETE all existing service lines
 *
 * **Example request:**
 * ```json
 * {
 * "total_charged_amount": "600.00",
 * "service_lines": [
 * {
 * "service_line_id": "LINE-ABC123",
 * "procedure_code": "99213",
 * "charged_amount": "250.00"
 * },
 * {
 * "procedure_code": "99215",
 * "charged_amount": "350.00"
 * }
 * ]
 * }
 * ```
 *
 * **Returns:** Updated PatientClaim with all current service_lines
 */
export const updatePatientClaimDocumentsDocumentKeyEobClaimsClaimKeyPutMutation = (options?: Partial<Options<UpdatePatientClaimDocumentsDocumentKeyEobClaimsClaimKeyPutData>>): UseMutationOptions<UpdatePatientClaimDocumentsDocumentKeyEobClaimsClaimKeyPutResponse, UpdatePatientClaimDocumentsDocumentKeyEobClaimsClaimKeyPutError, Options<UpdatePatientClaimDocumentsDocumentKeyEobClaimsClaimKeyPutData>> => {
    const mutationOptions: UseMutationOptions<UpdatePatientClaimDocumentsDocumentKeyEobClaimsClaimKeyPutResponse, UpdatePatientClaimDocumentsDocumentKeyEobClaimsClaimKeyPutError, Options<UpdatePatientClaimDocumentsDocumentKeyEobClaimsClaimKeyPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updatePatientClaimDocumentsDocumentKeyEobClaimsClaimKeyPut({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const validateEobProcessingDocumentsDocumentKeyEobValidatePostQueryKey = (options: Options<ValidateEobProcessingDocumentsDocumentKeyEobValidatePostData>) => createQueryKey('validateEobProcessingDocumentsDocumentKeyEobValidatePost', options);

/**
 * Mark EOB document as reviewed and complete processing
 * Mark EOB document processing as complete and reviewed.
 *
 * Sets document review_status to REVIEWED and creates an audit trail event
 * with type EOB_PROCESSING_FINISHED to track the validation action.
 *
 * **Returns:** Status confirmation with new review status
 */
export const validateEobProcessingDocumentsDocumentKeyEobValidatePostOptions = (options: Options<ValidateEobProcessingDocumentsDocumentKeyEobValidatePostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await validateEobProcessingDocumentsDocumentKeyEobValidatePost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: validateEobProcessingDocumentsDocumentKeyEobValidatePostQueryKey(options)
    });
};

/**
 * Mark EOB document as reviewed and complete processing
 * Mark EOB document processing as complete and reviewed.
 *
 * Sets document review_status to REVIEWED and creates an audit trail event
 * with type EOB_PROCESSING_FINISHED to track the validation action.
 *
 * **Returns:** Status confirmation with new review status
 */
export const validateEobProcessingDocumentsDocumentKeyEobValidatePostMutation = (options?: Partial<Options<ValidateEobProcessingDocumentsDocumentKeyEobValidatePostData>>): UseMutationOptions<ValidateEobProcessingDocumentsDocumentKeyEobValidatePostResponse, ValidateEobProcessingDocumentsDocumentKeyEobValidatePostError, Options<ValidateEobProcessingDocumentsDocumentKeyEobValidatePostData>> => {
    const mutationOptions: UseMutationOptions<ValidateEobProcessingDocumentsDocumentKeyEobValidatePostResponse, ValidateEobProcessingDocumentsDocumentKeyEobValidatePostError, Options<ValidateEobProcessingDocumentsDocumentKeyEobValidatePostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await validateEobProcessingDocumentsDocumentKeyEobValidatePost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listCarCsConfigCarcsGetQueryKey = (options?: Options<ListCarCsConfigCarcsGetData>) => createQueryKey('listCarCsConfigCarcsGet', options);

/**
 * List Carcs
 */
export const listCarCsConfigCarcsGetOptions = (options?: Options<ListCarCsConfigCarcsGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listCarCsConfigCarcsGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listCarCsConfigCarcsGetQueryKey(options)
    });
};

export const listRarCsConfigRarcsGetQueryKey = (options?: Options<ListRarCsConfigRarcsGetData>) => createQueryKey('listRarCsConfigRarcsGet', options);

/**
 * List Rarcs
 */
export const listRarCsConfigRarcsGetOptions = (options?: Options<ListRarCsConfigRarcsGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listRarCsConfigRarcsGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listRarCsConfigRarcsGetQueryKey(options)
    });
};

export const listNateraTagsConfigTagsGetQueryKey = (options?: Options<ListNateraTagsConfigTagsGetData>) => createQueryKey('listNateraTagsConfigTagsGet', options);

/**
 * List Natera Tags
 */
export const listNateraTagsConfigTagsGetOptions = (options?: Options<ListNateraTagsConfigTagsGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listNateraTagsConfigTagsGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listNateraTagsConfigTagsGetQueryKey(options)
    });
};

export const getCarcToRarcMappingConfigCarcToRarcGetQueryKey = (options?: Options<GetCarcToRarcMappingConfigCarcToRarcGetData>) => createQueryKey('getCarcToRarcMappingConfigCarcToRarcGet', options);

/**
 * Get Carc To Rarc Mapping
 */
export const getCarcToRarcMappingConfigCarcToRarcGetOptions = (options?: Options<GetCarcToRarcMappingConfigCarcToRarcGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCarcToRarcMappingConfigCarcToRarcGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getCarcToRarcMappingConfigCarcToRarcGetQueryKey(options)
    });
};

export const listMedistreamConsignmentsMedistreamTrackingGetQueryKey = (options?: Options<ListMedistreamConsignmentsMedistreamTrackingGetData>) => createQueryKey('listMedistreamConsignmentsMedistreamTrackingGet', options);

/**
 * List Medistream Consignments
 */
export const listMedistreamConsignmentsMedistreamTrackingGetOptions = (options?: Options<ListMedistreamConsignmentsMedistreamTrackingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listMedistreamConsignmentsMedistreamTrackingGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listMedistreamConsignmentsMedistreamTrackingGetQueryKey(options)
    });
};

export const medistreamTrackingSummaryMedistreamTrackingSummaryGetQueryKey = (options?: Options<MedistreamTrackingSummaryMedistreamTrackingSummaryGetData>) => createQueryKey('medistreamTrackingSummaryMedistreamTrackingSummaryGet', options);

/**
 * Medistream Tracking Summary
 */
export const medistreamTrackingSummaryMedistreamTrackingSummaryGetOptions = (options?: Options<MedistreamTrackingSummaryMedistreamTrackingSummaryGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await medistreamTrackingSummaryMedistreamTrackingSummaryGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: medistreamTrackingSummaryMedistreamTrackingSummaryGetQueryKey(options)
    });
};

export const downloadMedistreamTrackingReportCsvMedistreamTrackingReportGetQueryKey = (options?: Options<DownloadMedistreamTrackingReportCsvMedistreamTrackingReportGetData>) => createQueryKey('downloadMedistreamTrackingReportCsvMedistreamTrackingReportGet', options);

/**
 * Download Medistream Tracking Report Csv
 * Return a presigned URL for the full report CSV.
 *
 * Rendered from the 4-hourly precomputed snapshot; status and aging fields are
 * recalculated at request time so they are never stale. Onshore users only —
 * the report spans all consignments, including onshore-only documents.
 */
export const downloadMedistreamTrackingReportCsvMedistreamTrackingReportGetOptions = (options?: Options<DownloadMedistreamTrackingReportCsvMedistreamTrackingReportGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await downloadMedistreamTrackingReportCsvMedistreamTrackingReportGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: downloadMedistreamTrackingReportCsvMedistreamTrackingReportGetQueryKey(options)
    });
};

export const medistreamTrackingReportSummaryMedistreamTrackingReportSummaryGetQueryKey = (options?: Options<MedistreamTrackingReportSummaryMedistreamTrackingReportSummaryGetData>) => createQueryKey('medistreamTrackingReportSummaryMedistreamTrackingReportSummaryGet', options);

/**
 * Medistream Tracking Report Summary
 */
export const medistreamTrackingReportSummaryMedistreamTrackingReportSummaryGetOptions = (options?: Options<MedistreamTrackingReportSummaryMedistreamTrackingReportSummaryGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await medistreamTrackingReportSummaryMedistreamTrackingReportSummaryGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: medistreamTrackingReportSummaryMedistreamTrackingReportSummaryGetQueryKey(options)
    });
};

export const refreshMedistreamTrackingReportMedistreamTrackingReportRefreshPostQueryKey = (options?: Options<RefreshMedistreamTrackingReportMedistreamTrackingReportRefreshPostData>) => createQueryKey('refreshMedistreamTrackingReportMedistreamTrackingReportRefreshPost', options);

/**
 * Refresh Medistream Tracking Report
 * Trigger an out-of-band snapshot rebuild. Returns immediately.
 */
export const refreshMedistreamTrackingReportMedistreamTrackingReportRefreshPostOptions = (options?: Options<RefreshMedistreamTrackingReportMedistreamTrackingReportRefreshPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await refreshMedistreamTrackingReportMedistreamTrackingReportRefreshPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: refreshMedistreamTrackingReportMedistreamTrackingReportRefreshPostQueryKey(options)
    });
};

/**
 * Refresh Medistream Tracking Report
 * Trigger an out-of-band snapshot rebuild. Returns immediately.
 */
export const refreshMedistreamTrackingReportMedistreamTrackingReportRefreshPostMutation = (options?: Partial<Options<RefreshMedistreamTrackingReportMedistreamTrackingReportRefreshPostData>>): UseMutationOptions<RefreshMedistreamTrackingReportMedistreamTrackingReportRefreshPostResponse, DefaultError, Options<RefreshMedistreamTrackingReportMedistreamTrackingReportRefreshPostData>> => {
    const mutationOptions: UseMutationOptions<RefreshMedistreamTrackingReportMedistreamTrackingReportRefreshPostResponse, DefaultError, Options<RefreshMedistreamTrackingReportMedistreamTrackingReportRefreshPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await refreshMedistreamTrackingReportMedistreamTrackingReportRefreshPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listDocumentsWithAgentRunsDocumentAgentRunsGetQueryKey = (options?: Options<ListDocumentsWithAgentRunsDocumentAgentRunsGetData>) => createQueryKey('listDocumentsWithAgentRunsDocumentAgentRunsGet', options);

/**
 * List Documents With Agent Runs
 */
export const listDocumentsWithAgentRunsDocumentAgentRunsGetOptions = (options?: Options<ListDocumentsWithAgentRunsDocumentAgentRunsGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listDocumentsWithAgentRunsDocumentAgentRunsGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listDocumentsWithAgentRunsDocumentAgentRunsGetQueryKey(options)
    });
};

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = {
        ...queryKey[0]
    };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const listDocumentsWithAgentRunsDocumentAgentRunsGetInfiniteQueryKey = (options?: Options<ListDocumentsWithAgentRunsDocumentAgentRunsGetData>): QueryKey<Options<ListDocumentsWithAgentRunsDocumentAgentRunsGetData>> => createQueryKey('listDocumentsWithAgentRunsDocumentAgentRunsGet', options, true);

/**
 * List Documents With Agent Runs
 */
export const listDocumentsWithAgentRunsDocumentAgentRunsGetInfiniteOptions = (options?: Options<ListDocumentsWithAgentRunsDocumentAgentRunsGetData>) => {
    return infiniteQueryOptions<ListDocumentsWithAgentRunsDocumentAgentRunsGetResponse, ListDocumentsWithAgentRunsDocumentAgentRunsGetError, InfiniteData<ListDocumentsWithAgentRunsDocumentAgentRunsGetResponse>, QueryKey<Options<ListDocumentsWithAgentRunsDocumentAgentRunsGetData>>, string | null | Pick<QueryKey<Options<ListDocumentsWithAgentRunsDocumentAgentRunsGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListDocumentsWithAgentRunsDocumentAgentRunsGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listDocumentsWithAgentRunsDocumentAgentRunsGet({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listDocumentsWithAgentRunsDocumentAgentRunsGetInfiniteQueryKey(options)
    });
};

export const listADocumentSAgentRunsDocumentAgentDocumentsKeyRunsGetQueryKey = (options: Options<ListADocumentSAgentRunsDocumentAgentDocumentsKeyRunsGetData>) => createQueryKey('listADocumentSAgentRunsDocumentAgentDocumentsKeyRunsGet', options);

/**
 * List A Document'S Agent Runs
 */
export const listADocumentSAgentRunsDocumentAgentDocumentsKeyRunsGetOptions = (options: Options<ListADocumentSAgentRunsDocumentAgentDocumentsKeyRunsGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listADocumentSAgentRunsDocumentAgentDocumentsKeyRunsGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listADocumentSAgentRunsDocumentAgentDocumentsKeyRunsGetQueryKey(options)
    });
};

export const getAnAgentRunDocumentAgentDocumentsKeyRunsRunIdGetQueryKey = (options: Options<GetAnAgentRunDocumentAgentDocumentsKeyRunsRunIdGetData>) => createQueryKey('getAnAgentRunDocumentAgentDocumentsKeyRunsRunIdGet', options);

/**
 * Get An Agent Run
 */
export const getAnAgentRunDocumentAgentDocumentsKeyRunsRunIdGetOptions = (options: Options<GetAnAgentRunDocumentAgentDocumentsKeyRunsRunIdGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAnAgentRunDocumentAgentDocumentsKeyRunsRunIdGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAnAgentRunDocumentAgentDocumentsKeyRunsRunIdGetQueryKey(options)
    });
};

export const getTheDocumentTextTheAgentReadDocumentAgentDocumentsKeyTextGetQueryKey = (options: Options<GetTheDocumentTextTheAgentReadDocumentAgentDocumentsKeyTextGetData>) => createQueryKey('getTheDocumentTextTheAgentReadDocumentAgentDocumentsKeyTextGet', options);

/**
 * Get The Document Text The Agent Read
 */
export const getTheDocumentTextTheAgentReadDocumentAgentDocumentsKeyTextGetOptions = (options: Options<GetTheDocumentTextTheAgentReadDocumentAgentDocumentsKeyTextGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getTheDocumentTextTheAgentReadDocumentAgentDocumentsKeyTextGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getTheDocumentTextTheAgentReadDocumentAgentDocumentsKeyTextGetQueryKey(options)
    });
};

export const getTheGoldSetReviewQueueGoldSetQueueGetQueryKey = (options?: Options<GetTheGoldSetReviewQueueGoldSetQueueGetData>) => createQueryKey('getTheGoldSetReviewQueueGoldSetQueueGet', options);

/**
 * Get The Gold-Set Review Queue
 */
export const getTheGoldSetReviewQueueGoldSetQueueGetOptions = (options?: Options<GetTheGoldSetReviewQueueGoldSetQueueGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getTheGoldSetReviewQueueGoldSetQueueGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getTheGoldSetReviewQueueGoldSetQueueGetQueryKey(options)
    });
};

export const listTheGoldSetCategoriesGoldSetCategoriesGetQueryKey = (options?: Options<ListTheGoldSetCategoriesGoldSetCategoriesGetData>) => createQueryKey('listTheGoldSetCategoriesGoldSetCategoriesGet', options);

/**
 * List The Gold-Set Categories
 */
export const listTheGoldSetCategoriesGoldSetCategoriesGetOptions = (options?: Options<ListTheGoldSetCategoriesGoldSetCategoriesGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listTheGoldSetCategoriesGoldSetCategoriesGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listTheGoldSetCategoriesGoldSetCategoriesGetQueryKey(options)
    });
};

export const getAGoldSetDocumentGoldSetDocumentsKeyGetQueryKey = (options: Options<GetAGoldSetDocumentGoldSetDocumentsKeyGetData>) => createQueryKey('getAGoldSetDocumentGoldSetDocumentsKeyGet', options);

/**
 * Get A Gold-Set Document
 */
export const getAGoldSetDocumentGoldSetDocumentsKeyGetOptions = (options: Options<GetAGoldSetDocumentGoldSetDocumentsKeyGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAGoldSetDocumentGoldSetDocumentsKeyGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAGoldSetDocumentGoldSetDocumentsKeyGetQueryKey(options)
    });
};

/**
 * Save A Gold-Set Label
 */
export const saveAGoldSetLabelGoldSetDocumentsKeyLabelPutMutation = (options?: Partial<Options<SaveAGoldSetLabelGoldSetDocumentsKeyLabelPutData>>): UseMutationOptions<SaveAGoldSetLabelGoldSetDocumentsKeyLabelPutResponse, SaveAGoldSetLabelGoldSetDocumentsKeyLabelPutError, Options<SaveAGoldSetLabelGoldSetDocumentsKeyLabelPutData>> => {
    const mutationOptions: UseMutationOptions<SaveAGoldSetLabelGoldSetDocumentsKeyLabelPutResponse, SaveAGoldSetLabelGoldSetDocumentsKeyLabelPutError, Options<SaveAGoldSetLabelGoldSetDocumentsKeyLabelPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await saveAGoldSetLabelGoldSetDocumentsKeyLabelPut({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};